<div [loading]="loading">
  <ul>
    <li *ngFor="let parcel of data?.list?.list">
      <a uiSref="symap.project.parcels.detail" [uiParams]="{ id: parcel.id }">{{ parcel | parcelnumber }}</a>
    </li>
  </ul>
  <div *ngIf="data?.list?.list && data.list.list.length === 0">Žádné parcely</div>
</div>
